<template lang="pug">
validation-observer(ref='form', v-slot='{ handleSubmit }')
  form.form.employment(@submit.prevent='handleSubmit(onNext)')
    h3.form-title.text-center ส่วนที่ 4 ประวัติการทำงาน (Employment Record)
      small.d-block เรียงลำดับจากปัจจุบันลงไป (Present to past)

    .employment-item(v-for='(item, index) in employmentRecord')
      h4.form-subtitle ประวัติการทำงานที่ {{ index + 1 }}
        button.employment-remove(@click='remove($event, index)') ลบ

      .form-item.has-bg
        .row
          .col-sm-6
            .row
              label.col-sm-3(:for='`companyName${index}`') ชื่อบริษัท

              .col-sm-9
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='ชื่อบริษัท'
                  )
                    input.form-control(
                      :id='`companyName${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='text',
                      v-model='item.company_name',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-6
            .row
              label.col-sm-3.text-right(:for='`businessType${index}`') ลักษณะธุรกิจ

              .col-sm-9
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='ลักษณะธุรกิจ'
                  )
                    input.form-control(
                      :id='`businessType${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='text',
                      v-model='item.business_type',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

      .form-item
        .row
          .col-sm-4
            .row
              label.col-sm-4(:for='`position${index}`') ตำแหน่งงาน

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='ตำแหน่งงาน'
                  )
                    input.form-control(
                      :id='`position${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='text',
                      v-model='item.position',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-4.text-right(:for='`since${index}`') วันที่เข้าทำงาน

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='วันที่เข้าทำงาน'
                  )
                    input.form-control(
                      :id='`since${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='date',
                      v-model='item.since',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-4.text-right(:for='`to${index}`') วันที่ลาออก

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='วันที่ลาออก'
                  )
                    input.form-control(
                      :id='`to${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='date',
                      v-model='item.to',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

      .form-item.has-bg
        .row
          .col-sm-6
            .row
              label.col-sm-3(:for='`job${index}`') งานที่รับผิดชอบ

              .col-sm-9
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='งานที่รับผิดชอบ'
                  )
                    input.form-control(
                      :id='`job${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='text',
                      v-model='item.responsible_work',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-6
            .row
              label.col-sm-3(:for='`resignation${index}`') สาหตุที่ลาออก

              .col-sm-9
                .form-group
                  validation-provider(
                    v-slot='{ errors, valid }',
                    rules='required',
                    name='สาหตุที่ลาออก'
                  )
                    input.form-control(
                      :id='`resignation${index}`',
                      :class='{ "is-invalid": errors[0], "is-valid": valid }',
                      type='text',
                      v-model='item.resignation',
                      @input='onChange'
                    )
                    span.invalid-feedback {{ errors[0] }}

    button.employment-add(@click='generate') + เพิ่มประวัติการทำงาน

    .form-footer
      .d-flex.justify-content-center
        button.back(@click='$store.commit("SET_STEP", 3)') กลับสู่ก่อนหน้า
        button.next(type='submit') บันทึกและไปขั้นต่อไป
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    users: [],
  }),

  computed: {
    ...mapState(['employmentRecord']),
  },

  methods: {
    generate() {
      this.employmentRecord.push({
        since: '',
        to: '',
        position: '',
        company_name: '',
        business_type: '',
        job: '',
        resignation: '',
        default: false,
      })

      this.$store.commit('SET_EMPLOYMENT_RECORD', this.employmentRecord)
    },

    remove(e, index) {
      this.$delete(this.employmentRecord, index)
      this.$store.commit('SET_EMPLOYMENT_RECORD', this.employmentRecord)
      // e.target.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode)
    },

    onChange() {
      this.$store.commit('SET_EMPLOYMENT_RECORD', this.employmentRecord)
    },

    onNext() {
      this.loading = true
      try {
        this.$store.commit('SET_STEP', 5)
      } catch (error) {
        const errors = error.response.data.errors
        this.$refs.form.setErrors(errors)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.employment {
  &-item {
    margin-bottom: 4rem;

    .col-sm-8 {
      padding-left: 38px;
    }
  }

  &-add {
    width: 100%;
    text-align: center;
    color: #0f4c98;
    font-size: 20px;
    line-height: 1;
    font-weight: 600;
    display: block;
    padding: 2rem 0;
    background: #f5f5f5;
    border: none;
    outline: none;
  }

  &-remove {
    position: absolute;
    right: 4rem;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    border: none;
    padding: 0.5rem 1rem;
    background: #0f4c98;
    outline: none;
  }
}
</style>
